<template>
  <div>
    <Panel
      v-for="(w, i) in availableSteps"
      :key="i"
      lineColor="var(--primary-color)"
      class="text-start mb-5"
    >
      <v-row>
        <v-col cols="auto">
          <v-img :src="getIcon(w)" max-width="40" class="mr-4" />
        </v-col>
        <v-col>
          {{ w.titulo }}
        </v-col>
        <v-col cols="auto">
          <FormButton
            :color="i === 0 ? 'orange' : 'grey'"
            :disabled="i > 0"
            @click="$emit('navigate', w)"
          >
            Clique aqui
          </FormButton>
        </v-col>
      </v-row>
    </Panel>
    <Panel
      v-if="availableSteps.length <= 0 && lastStep && !canPublish"
      lineColor="var(--primary-color)"
      class="text-start mb-5"
    >
      <v-row>
        <v-col cols="auto">
          <v-img :src="getIcon(lastStep)" max-width="40" class="mr-4" />
        </v-col>
        <v-col>
          {{ lastStep.mensagem.info }}
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <FormButton
            v-if="!canPublish"
            color="grey"
            outlined
            class="mr-2"
            disabled
          >
            Aguardando pagamento
          </FormButton>
          <FormButton color="orange" @click="$emit('navigate', lastStep)">
            Editar informações
          </FormButton>
        </v-col>
      </v-row>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";

export default {
  name: "WizardActions",
  components: { Panel, FormButton },
  props: {
    availableSteps: {
      type: Array,
      required: true
    },
    lastStep: {
      type: Object,
      required: false
    },
    canPublish: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    getIcon(step) {
      if (!step) return "";
      const { query_resolucao } = step;
      const basePath = query_resolucao
        ? require(`@/assets/icons/wizard/a-${step.icone}.png`)
        : require(`@/assets/icons/wizard/${step.icone}.png`);
      return basePath;
    }
  }
};
</script>
